import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="成人高清学历提升平台 - 在职进修首选"
        description="成人高清学历提升平台专为在职人士设计，提供高清视频课程、名师直播辅导与灵活学习方案。报考成人高考、自学考试、网络教育，轻松获得国家认可学历，助力职场晋升与薪资提升。"
        keywords="成人高清,成人高考,高清视频课程,学历提升,在职进修,成人教育,网络教育"
        canonicalUrl="https://www.chengrengaoqing.com/"
        ogTitle="成人高清学历提升平台 - 在职进修首选"
        ogDescription="专为在职人士设计的高清视频课程平台，涵盖成人高考、自学考试、网络教育、国家开放大学等多种学历提升方案。"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20education%20platform%20banner%20with%20minimalist%20design%2C%20soft%20amber%20and%20cream%20gradient%2C%20modern%20clean%20aesthetic%2C%20no%20text&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <SchemaOrg type="Organization" data={{}} />
      <SchemaOrg type="WebSite" data={{}} />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '成人高清学历提升平台 - 首页',
          description: '在职人士学历提升首选平台，提供成人高考、自学考试、网络教育、国家开放大学等学历提升方案。',
          url: 'https://www.chengrengaoqing.com/',
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <CategoriesSection />
          <StatsSection />
          <ArticlesSection />
          <TestimonialsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}